import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Dil dosyalarını içe aktarıyoruz
import tr from "@/i18n/locales/tr.json" assert { type: "json" };
import en from "@/i18n/locales/en.json" assert { type: "json" };
import de from "@/i18n/locales/de.json" assert { type: "json" };
import ar from "@/i18n/locales/ar.json" assert { type: "json" };
import es from "@/i18n/locales/es.json" assert { type: "json" };
import fr from "@/i18n/locales/fr.json" assert { type: "json" };
import it from "@/i18n/locales/it.json" assert { type: "json" };
import { getUILocale, UI_LANGUAGES } from "@/i18n/languages";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: { translation: tr },
      en: { translation: en },
      de: { translation: de },
      ar: { translation: ar },
      es: { translation: es },
      fr: { translation: fr },
      it: { translation: it },
    },
    supportedLngs: UI_LANGUAGES.map(({ locale }) => locale),
    load: "languageOnly",
    fallbackLng: "en",
    detection: {
      // 🌍 WebView Detection Order:
      // 1. URL query parameter (?lang=tr)
      // 2. localStorage (postMessage ile set edilmiş olabilir)
      // 3. navigator (browser default)
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang", // ?lang=tr formatında
      lookupLocalStorage: "i18nextLng",
      caches: ["localStorage"], // localStorage'da cache'le
      convertDetectedLanguage: getUILocale,
    },
    interpolation: {
      escapeValue: false,
    },
  });

const syncDocumentLanguage = () => {
  if (typeof document === "undefined") return;
  const locale = getUILocale(i18n.resolvedLanguage || i18n.language);
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === "ar" ? "rtl" : "ltr";
};
i18n.on("languageChanged", syncDocumentLanguage);
syncDocumentLanguage();

export default i18n;
